import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SgStepsProgressBarComponent } from './steps-progress-bar/steps-progress-bar.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SgStepsProgressBarComponent],
  imports: [CommonModule, MatIconModule],
  exports: [SgStepsProgressBarComponent],
})
export class SgStepsProgressBarModule {}
